import { render, staticRenderFns } from "./ShortName.vue?vue&type=template&id=8edc4c16"
import script from "./ShortName.vue?vue&type=script&lang=js"
export * from "./ShortName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports